export default {
  title: {
    en: 'Your card\'s security code (CVV/CVC) is incorrect.',
  },
  description: {
    en: 'Please, enter another security code.',
  },
  buttonTitle: {
    en: 'Got it',
  },
}
